import { createCachedSelector } from "re-reselect";

import { getLegSourceNamesFromTripPrices as getLegSourceNamesHelper } from "@app/helpers/udm/get-leg-source-names";

import { getSearchedLegByTripId } from "../trips/get-leg";
import { getTripById } from "../trips/get-trip";

export const getLegSourceNames = createCachedSelector(
  [getSearchedLegByTripId, getTripById],
  getLegSourceNamesHelper
)((_state, trip_id) => trip_id);
